/**
 * テレビ向け表示の共通設定
 */

export {
  TV_STATION_ID,
  TV_STATION_IMAGE,
  TV_SPOT_IDS,
  TV_SPOT_DEFAULT,
  TV_SPOT_LOCATION_OPTIONS,
  getTvSpotConfig,
  getTvSpotPanelTitles,
} from './tvSpotLocation';

export const TV_QR_IMAGE = '/assets/QR.png';
export const TV_QR_URL = 'https://ai-camera.lab.mdg-meidai.com/tv';
export const TV_QR_SUBTITLE = 'グラフベースダッシュボード';

/** 表示時間帯（API取得は7〜22時、表に出すのは昼〜夕方の中心帯） */
export const TV_DISPLAY_HOURS = [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];

export const TV_HEATMAP_COPY = {
  /** ヒートマップ直上の凡例（画面2・3） */
  scaleTitle: '人の量',
  scaleSteps: [
    { value: 1, label: '少ない' },
    { value: 10, label: 'ふつう' },
    { value: 20, label: '多い' },
  ],
  /** 旧パネル用（ストーリーボード等） */
  scaleNote: '1が少ない → 20が多い',
  todayTitle: '今日、どこがにぎわう？',
  todayTitleSuffix: '（全12地点）',
  weeklyTitlePrefix: 'の1週間のにぎわい',
  rowHeaderLocation: '商店街',
  rowHeaderTime: '時間',
};
